import {PickerColumn} from 'src/tracker/model/column/tracker-column'
import {silverArmorProperty} from 'src/tracker/model/property/equipment/armor/silver-armor-property'

export const silverArmorColumn = new PickerColumn(
  "95px",
  silverArmorProperty
)
